import styled from '@emotion/styled'

export default styled.p`
  text-align: left;
  line-height: 1.7;
`
